import React, { useState } from "react";
import { IconCopy, IconShare } from "@tabler/icons-react";
import Copied from "../../../../Components/Copied/Copied";

const iconBtn =
  "inline-flex items-center justify-center border border-mauve-300 bg-mauve-700 px-3 py-2 text-white hover:bg-mauve-800";

export default ({ shareData, copyOnly, ...rest }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const { title, text, url } = shareData;
  const shareAvailability = navigator.share;

  const handleCopy = async () => {
    const value = url || text;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        // Fallback for older browsers / insecure contexts
        const el = document.createElement("textarea");
        el.value = value;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Copied snapToMy="right" visible={copySuccess} />
      <button type="button" className={iconBtn} onClick={handleCopy}>
        <IconCopy className="size-4" />
      </button>
      {shareAvailability ? (
        <button
          type="button"
          className={iconBtn}
          onClick={() => {
            navigator
              .share({ title, text, url })
              .then(() => console.log("Thanks for sharing!"))
              .catch((err) => console.error(err));
          }}
          {...rest}
        >
          <IconShare className="size-4" />
        </button>
      ) : null}
    </>
  );
};
